import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { DESIGN_SYSTEM_PATH } from "@components/dev/playgroundComponents";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useSettings } from "../../settings/SettingsProvider";
import { UserSettingsPages } from "../../settings/constants";

export const AccountSettingsItems: React.FC = () => {
    const navigate = useStateAwareNavigate();
    const { open: openSettings } = useSettings();
    const {
        personalAccessTokens: patsFlagEnabled,
        componentsPlayground: isComponentsPlaygroundEnabled,
    } = useTypedFlags();

    return (
        <Menu.Group>
            <Menu.GroupLabel>My account</Menu.GroupLabel>
            <Menu.Item onClick={() => openSettings(["general"])}>
                Profile
            </Menu.Item>
            <Menu.Item onClick={() => openSettings(["notifications"])}>
                Notifications
            </Menu.Item>
            <Menu.Item onClick={() => openSettings(["security"])}>
                Security
            </Menu.Item>
            {patsFlagEnabled && (
                <Menu.Item
                    onClick={() => openSettings([UserSettingsPages.MCP_CLI])}
                >
                    Connectors
                </Menu.Item>
            )}
            {isComponentsPlaygroundEnabled && (
                <Menu.Item onClick={() => navigate(DESIGN_SYSTEM_PATH)}>
                    Design system
                </Menu.Item>
            )}
        </Menu.Group>
    );
};
